module.exports = __webpack_public_path__ + "img/add-intercompany.dfc834dd.svg";